import React, { useEffect, useState } from "react";
import Account1 from "./pages/v1/Account1";
import { Route } from "./utilities/CustomRoute";
import { userService } from "./services/user.service";
import Home from "./pages/v1/Home";
import { userStore } from "./gStore/user.store";
import { GameDetail } from "./pages/v1/GameDetail";
import { Games } from "./pages/v1/Games";
import HowToPlay from "./pages/v1/HowToPlay";
import Feedback from "./pages/v1/Feedback";

export const Routes = ({ userId }: { userId: string }) => {
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    setLoading(true);
    userService
      .getUserBasicInfo(userId)
      .then((user) => {
        userStore.setUserData({
          payload: user,
        });
      })
      .catch((errMessage) => {
        console.log(errMessage);
      })
      .finally(() => {
        setLoading(false);
      });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading ? (
        <div>Loading</div>
      ) : (
        <>
          <Route queryPath="account" element={<Account1 />} />
          <Route queryPath="home" element={<Home />} />
          <Route queryPath="games" element={<Games />} />
          <Route queryPath="games-center" element={<Games />} />
          <Route queryPath="game-detail" element={<GameDetail />} />
          <Route queryPath="how-to-play" element={<HowToPlay />} />
          <Route queryPath="feedback" element={<Feedback />} />
        </>
      )}
    </>
  );
};
